import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useVerifyOTP = () => {
  const mutation = useMutation((otpForm) => {
    return axiosClient.post("/Authentication/VerifyOTP", otpForm);
  });
  return mutation;
};
export default useVerifyOTP;
